import React from 'react';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import AssetClass from './AssetClass';
import AssetType from './AssetType';
import AssetItem from './AssetItem';

const AssetMenu = () => {
    const [value, setValue] = React.useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
          <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChange} aria-label="Org's">
                    <Tab label="Asset Item" value="1" />
                    <Tab label="Asset Type" value="2" />
                    <Tab label="Asset Class" value="3" />                    
                </TabList>
                </Box>
                <TabPanel value="1">
                    <AssetItem />
                </TabPanel>
                <TabPanel value="2">
                    <AssetType />
                </TabPanel>
                <TabPanel value="3">
                    <AssetClass />
                </TabPanel>               
            </TabContext>
        </Box>
    );

  };
  
  export default AssetMenu;